import { Routes } from '@angular/router';
import { LoginPage } from './login.page';

export const loginRoutes: Routes = [
  { path: '', component: LoginPage }
];